'use strict';
/* eslint no-warning-comments: off */

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var parallel = require('async/parallel');

var once = require('once');

var debug = require('debug');

var log = debug('libp2p:switch:transport');

var LimitDialer = require('./limit-dialer'); // number of concurrent outbound dials to make per peer, same as go-libp2p-swtch


var defaultPerPeerRateLimit = 8; // the amount of time a single dial has to succeed
// TODO this should be exposed as a option

var dialTimeout = 30 * 1000;
/**
 * Manages the transports for the switch. This simplifies dialing and listening across
 * multiple transports.
 */

var TransportManager =
/*#__PURE__*/
function () {
  function TransportManager(_switch) {
    _classCallCheck(this, TransportManager);

    this.switch = _switch;
    this.dialer = new LimitDialer(defaultPerPeerRateLimit, dialTimeout);
  }
  /**
   * Adds a `Transport` to the list of transports on the switch, and assigns it to the given key
   *
   * @param {String} key
   * @param {Transport} transport
   * @returns {void}
   */


  _createClass(TransportManager, [{
    key: "add",
    value: function add(key, transport) {
      log('adding %s', key);

      if (this.switch.transports[key]) {
        throw new Error('There is already a transport with this key');
      }

      this.switch.transports[key] = transport;

      if (!this.switch.transports[key].listeners) {
        this.switch.transports[key].listeners = [];
      }
    }
    /**
     * Closes connections for the given transport key
     * and removes it from the switch.
     *
     * @param {String} key
     * @param {function(Error)} callback
     * @returns {void}
     */

  }, {
    key: "remove",
    value: function remove(key, callback) {
      var _this = this;

      callback = callback || function () {};

      if (!this.switch.transports[key]) {
        return callback();
      }

      this.close(key, function (err) {
        delete _this.switch.transports[key];
        callback(err);
      });
    }
    /**
     * Calls `remove` on each transport the switch has
     *
     * @param {function(Error)} callback
     * @returns {void}
     */

  }, {
    key: "removeAll",
    value: function removeAll(callback) {
      var _this2 = this;

      var tasks = Object.keys(this.switch.transports).map(function (key) {
        return function (cb) {
          _this2.remove(key, cb);
        };
      });
      parallel(tasks, callback);
    }
    /**
     * For a given transport `key`, dial to all that transport multiaddrs
     *
     * @param {String} key Key of the `Transport` to dial
     * @param {PeerInfo} peerInfo
     * @param {function(Error, Connection)} callback
     * @returns {void}
     */

  }, {
    key: "dial",
    value: function dial(key, peerInfo, callback) {
      var _this3 = this;

      var transport = this.switch.transports[key];
      var multiaddrs = peerInfo.multiaddrs.toArray();

      if (!Array.isArray(multiaddrs)) {
        multiaddrs = [multiaddrs];
      } // filter the multiaddrs that are actually valid for this transport


      multiaddrs = TransportManager.dialables(transport, multiaddrs, this.switch._peerInfo);
      log('dialing %s', key, multiaddrs.map(function (m) {
        return m.toString();
      })); // dial each of the multiaddrs with the given transport

      this.dialer.dialMany(peerInfo.id, transport, multiaddrs, function (err, success) {
        if (err) {
          return callback(err);
        }

        peerInfo.connect(success.multiaddr);

        _this3.switch._peerBook.put(peerInfo);

        callback(null, success.conn);
      });
    }
    /**
     * For a given Transport `key`, listen on all multiaddrs in the switch's `_peerInfo`.
     * If a `handler` is not provided, the Switch's `protocolMuxer` will be used.
     *
     * @param {String} key
     * @param {*} _options Currently ignored
     * @param {function(Connection)} handler
     * @param {function(Error)} callback
     * @returns {void}
     */

  }, {
    key: "listen",
    value: function listen(key, _options, handler, callback) {
      var _this4 = this;

      handler = this.switch._connectionHandler(key, handler);
      var transport = this.switch.transports[key];
      var multiaddrs = TransportManager.dialables(transport, this.switch._peerInfo.multiaddrs.distinct());

      if (!transport.listeners) {
        transport.listeners = [];
      }

      var freshMultiaddrs = [];
      var createListeners = multiaddrs.map(function (ma) {
        return function (cb) {
          var done = once(cb);
          var listener = transport.createListener(handler);
          listener.once('error', done);
          listener.listen(ma, function (err) {
            if (err) {
              return done(err);
            }

            listener.removeListener('error', done);
            listener.getAddrs(function (err, addrs) {
              if (err) {
                return done(err);
              }

              freshMultiaddrs = freshMultiaddrs.concat(addrs);
              transport.listeners.push(listener);
              done();
            });
          });
        };
      });
      parallel(createListeners, function (err) {
        if (err) {
          return callback(err);
        } // cause we can listen on port 0 or 0.0.0.0


        _this4.switch._peerInfo.multiaddrs.replace(multiaddrs, freshMultiaddrs);

        callback();
      });
    }
    /**
     * Closes the transport with the given key, by closing all of its listeners
     *
     * @param {String} key
     * @param {function(Error)} callback
     * @returns {void}
     */

  }, {
    key: "close",
    value: function close(key, callback) {
      var transport = this.switch.transports[key];

      if (!transport) {
        return callback(new Error("Trying to close non existing transport: ".concat(key)));
      }

      parallel(transport.listeners.map(function (listener) {
        return function (cb) {
          listener.close(cb);
        };
      }), callback);
    }
    /**
     * For a given transport, return its multiaddrs that match the given multiaddrs
     *
     * @param {Transport} transport
     * @param {Array<Multiaddr>} multiaddrs
     * @param {PeerInfo} peerInfo Optional - a peer whose addresses should not be returned
     * @returns {Array<Multiaddr>}
     */

  }], [{
    key: "dialables",
    value: function dialables(transport, multiaddrs, peerInfo) {
      // If we dont have a proper transport, return no multiaddrs
      if (!transport || !transport.filter) return [];
      var transportAddrs = transport.filter(multiaddrs);

      if (!peerInfo) {
        return transportAddrs;
      }

      return transportAddrs.filter(function (addr) {
        // If our address is in the destination address, filter it out
        return !peerInfo.multiaddrs.toArray().find(function (pAddr) {
          try {
            addr.decapsulate(pAddr);
          } catch (err) {
            return false;
          }

          return true;
        });
      });
    }
  }]);

  return TransportManager;
}();

module.exports = TransportManager;